import React from "react"
import { withRouter, Redirect } from "react-router-dom"
import { view } from "react-easy-state"
import firebase from "firebase-app"
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth"
import { message, Icon } from "antd"

import RegisterForm from "components/pages/students/register/RegisterForm"

import globalStore from "store"
import UsersService from "services/users.service"
import * as AuthHelper from "helpers/auth.helper"

class RegisterPage extends React.Component {
  constructor(props) {
    super(props)

    this.uiConfig = {
      signInFlow: "popup",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      ],
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectURL) => {
          const { credential } = authResult
          this.handleAuthResult(credential)
          return false
        },
        uiShown: () => {
          // Change Text of Social Buttons
          const googleButtonLabel = document.querySelector(
            ".firebaseui-idp-google .firebaseui-idp-text.firebaseui-idp-text-long"
          )
          const facebookButtonLabel = document.querySelector(
            ".firebaseui-idp-facebook .firebaseui-idp-text.firebaseui-idp-text-long"
          )

          googleButtonLabel &&
            (googleButtonLabel.innerHTML = "Register with Google")
          facebookButtonLabel &&
            (facebookButtonLabel.innerHTML = "Register with Facebook")

          this.setState({ socialButtonLoading: false })
        },
      },
    }

    this.state = {
      submitting: false,
      socialButtonLoading: true,
    }
  }

  handleAuthResult = (credential) => {
    const pageState = globalStore.ui.register

    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(async (idToken) => {
        const values = {
          idToken,
          providerId: credential.providerId,
        }

        await UsersService.firebaseLogin({ values, pageState })

        if (
          !pageState.loginErrors &&
          pageState.API_USERS_FIREBASE_LOGIN_STATUS === "fulfilled"
        ) {
          this.props.history.replace("/courses")
          return false
        }
        message.destroy()
        message.error("Please enter valid details") // have to parse errors or show inline form errors
        return false
      })
      .catch(function (error) {
        // Handle error
        message.destroy()
        message.error("Oops!! something went wrong.")
        console.log(error)
        // window.location.reload()
      })
  }

  componentDidMount() {
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        //this.socialRegister(user)
      }
    })
  }

  componentWillUnmount() {
    this.unregisterAuthObserver()
  }

  socialRegister = (user) => {
    //send `user` to backend and handle the response
    message.destroy()
    message.error("Social Login is not supported. Try manual register")

    AuthHelper.logout()
  }

  handleSubmit = (e, formProps) => {
    e.preventDefault()

    this.setState({ submitting: true })

    const pageState = globalStore.ui.register

    formProps.validateFields(async (err, values) => {
      if (err) {
        this.setState({ submitting: false })
        return
      }

      await UsersService.register({ values, pageState })

      if (
        !pageState.registerErrors &&
        pageState.API_USERS_REGISTER_STATUS === "fulfilled"
      ) {
        this.props.history.replace("/courses")
        return
      }

      if (pageState.registerErrors && pageState.registerErrors["email"]) {
        message.destroy()
        message.error(`Email ${pageState.registerErrors["email"]}`)
      } else if (
        pageState.registerErrors &&
        pageState.registerErrors["password_confirmation"]
      ) {
        message.destroy()
        message.error(
          `Password confirmation ${pageState.registerErrors["password_confirmation"]}`
        )
      } else {
        message.destroy()
        message.error("Please enter valid details") // have to parse errors or show inline form errors
      }

      this.setState({ submitting: false })
    })
  }

  render() {
    if (AuthHelper.isLoggedIn()) return <Redirect to="/courses" />

    const { submitting, socialButtonLoading } = this.state

    return (
      <div className="page student-auth-page">
        <div className="auth-form-logo">
          {/* TODO: Need to fix image url, use environment variable */}
          <img
            src={`${window.location.origin}/logo-inline-colored.png`}
            alt="Learner's logo"
          />
        </div>
        <RegisterForm onSubmit={this.handleSubmit} submitting={submitting}>
          <div className="social-login-wrapper">
            <StyledFirebaseAuth
              uiConfig={this.uiConfig}
              firebaseAuth={firebase.auth()}
            />
            {socialButtonLoading && (
              <div className="social-login-loader">
                <Icon type="loading" />
              </div>
            )}
          </div>
        </RegisterForm>
      </div>
    )
  }
}

export default withRouter(view(RegisterPage))
